import { render, staticRenderFns } from "./MyLists.vue?vue&type=template&id=49541674&scoped=true&"
import script from "./MyLists.vue?vue&type=script&lang=js&"
export * from "./MyLists.vue?vue&type=script&lang=js&"
import style0 from "./MyLists.vue?vue&type=style&index=0&id=49541674&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49541674",
  null
  
)

export default component.exports